// export const environment = {
//   countryCode: 'SE',
//   defaultLocation: [58.154950, 8.023647],
//   feedbackCategoryLevels: ['group', 'description', 'service_code'] as const,
//   jurisdiction: 'Kristiansand',
//   privacyPolicyUrl: 'https://www.goteborg.se/privacy',
//   production: false,
//   pushApiUrl: 'https://baltfloods-api.prod.appadem.in/push',
//   scheduledMessagesApiUrl: 'https://baltfloods-api.prod.appadem.in/messages',
//   radarApiKey: 'prj_live_pk_5e64787f858f7e3d4bebd08041dbc2b6f742a85c',
//   sentryDsn: '',
//   serviceApiApiKey: 'dev_key',
//   serviceApiJurisdictionId: 'kristiansand',
//   serviceApiUrl: 'https://baltfloods-api.prod.appadem.in/service-api',
//   observationApiUrl: 'https://baltfloods-api.prod.appadem.in/observation',
//   pocketbaseUrl: 'https://baltfloods-api.prod.appadem.in/api',
//   streetAiApiJurisdictionId: 'kristiansand',
//   streetAiApiKey: 'dev_key',
//   streetAiApiUrl: 'https://baltfloods-api.prod.appadem.in/street-ai',
//   streetAiUploadUrl: 'https://baltfloods-api.prod.appadem.in/uploads',
//   termsOfUseUrl: 'https://www.goteborg.se/terms',
//   trackingCode: '',
//   vapidPublicKey: 'your_public_vapid_key',
//   intoToApiUrl: 'https://api.intoto.io/api/v1',
//   intoToApiKey: 'pk_live_S82FYXF5TJF2_ygcFek4YGCuoJXZywOqvkMAuYmfwd7Zn5BsBCPGtH9E'
// };
// export const environment = {
//   countryCode: 'SE',
//   defaultLocation: [58.154950, 8.023647],
//   feedbackCategoryLevels: ['group', 'description', 'service_code'] as const,
//   jurisdiction: 'Kristiansand',
//   privacyPolicyUrl: 'https://www.goteborg.se/privacy',
//   production: false,
//   pushApiUrl: 'http://192.168.10.112:8090/push',
//   scheduledMessagesApiUrl: 'http://192.168.10.112:8090/messages',
//   radarApiKey: 'prj_live_pk_5e64787f858f7e3d4bebd08041dbc2b6f742a85c',
//   sentryDsn: '',
//   serviceApiApiKey: 'dev_key',
//   serviceApiJurisdictionId: 'kristiansand',
//   serviceApiUrl: 'http://192.168.10.112:8090/service-api',
//   observationApiUrl: 'http://192.168.10.112:8090/observation',
//   pocketbaseUrl: 'http://192.168.10.112:8090/api',
//   streetAiApiJurisdictionId: 'kristiansand',
//   streetAiApiKey: 'dev_key',
//   streetAiApiUrl: 'http://192.168.10.112:8090/street-ai',
//   streetAiUploadUrl: 'http://192.168.10.112:8090/uploads',
//   termsOfUseUrl: 'https://www.goteborg.se/terms',
//   trackingCode: '',
//   vapidPublicKey: 'your_public_vapid_key',
//   intoToApiUrl: 'https://api.intoto.io/api/v1',
//   intoToApiKey: 'pk_live_S82FYXF5TJF2_ygcFek4YGCuoJXZywOqvkMAuYmfwd7Zn5BsBCPGtH9E'
// };
export const environment = {
  countryCode: 'EE',
  defaultLocation: [59.4377385, 24.7330444],
  feedbackCategoryLevels: ['group', 'description', 'service_code'] as const,
  jurisdiction: 'Tallinn',
  privacyPolicyUrl: 'https://www.google.se',
  production: false,
  pushApiUrl: 'https://baltfloods-tallinn-api.prod.appadem.in/push',
  scheduledMessagesApiUrl: 'https://baltfloods-tallinn-api.prod.appadem.in/messages',
  radarApiKey: 'prj_live_pk_5e64787f858f7e3d4bebd08041dbc2b6f742a85c',
  sentryDsn: '',
  serviceApiApiKey: 'dev_key',
  serviceApiJurisdictionId: 'tallinn',
  serviceApiUrl: 'https://baltfloods-tallinn-api.prod.appadem.in/service-api',
  observationApiUrl: 'https://baltfloods-tallinn-api.prod.appadem.in/observation',
  pocketbaseUrl: 'https://baltfloods-tallinn-api.prod.appadem.in/api',
  streetAiApiJurisdictionId: 'tallinn',
  streetAiApiKey: 'dev_key',
  streetAiApiUrl: 'https://baltfloods-tallinn-api.prod.appadem.in/street-ai',
  streetAiUploadUrl: 'https://baltfloods-tallinn-api.prod.appadem.in/uploads',
  termsOfUseUrl: 'https://www.goteborg.se/terms',
  trackingCode: '',
  vapidPublicKey: 'your_public_vapid_key',
  intoToApiUrl: 'https://api.intoto.io/api/v1',
  intoToApiKey: 'pk_live_S82FYXF5TJF2_ygcFek4YGCuoJXZywOqvkMAuYmfwd7Zn5BsBCPGtH9E'
};
